/**
 * function to calculate the scaled down size of the image.
 * Dimensions are scaled down if the larger dimension of the image is greater than max of that dimension.
 */
export function calculateScaledDownSize({
  oldWidth,
  oldHeight,
  maxWidth,
  maxHeight,
}: {
  oldWidth: number;
  oldHeight: number;
  maxWidth: number;
  maxHeight: number;
}) {
  // check if any of the dimensions are not valid (i.e. less than or equal to 0)
  if (oldWidth <= 0 || oldHeight <= 0 || maxWidth <= 0 || maxHeight <= 0) {
    return { width: 0, height: 0 };
  }

  let width = oldWidth;
  let height = oldHeight;

  // calculate the width and height, constraining the proportions
  if (width > height) {
    if (width > maxWidth) {
      height = Math.round((height * maxWidth) / width);
      width = maxWidth;
    }
  } else {
    if (height > maxHeight) {
      width = Math.round((width * maxHeight) / height);
      height = maxHeight;
    }
  }
  return { width, height };
}
